import AvilabilityModal from './AvilabilityModal';

export default AvilabilityModal;
